import {
    Autocomplete,
    TextField,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel
} from "@mui/material"
import { H5, Body2, H6 } from "../../../themes/typography"

function BillingDetails({ formik, states = [], attendeesList = [] }) {
    // const attendees = formik.values.attendees || [];
    const uniqueAttendees = Array.isArray(attendeesList)
        ? attendeesList.filter((item, idx, arr) =>
            idx === arr.findIndex(i => (i.ticket_id ?? i.id) === (item.ticket_id ?? item.id))
        )
        : [];

    return (
        <div className='select-user-billing-details-container'>
            <H5>
                Billing Details
            </H5>
            <div className="user-state-selection-container">
                {/* <div className="user-name-billing-selection-label">
                    <H5>Select your state</H5>
                </div> */}
                <div className="user-state-billing-selection-input">
                    <Autocomplete
                        options={states}
                        getOptionLabel={(option) => option?.name || ""}
                        value={formik.values.state || null}
                        onChange={(event, newValue) => {
                            formik.setFieldValue("state", newValue);
                        }}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                                {option.name}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="State"
                                error={formik.touched.state && Boolean(formik.errors.state)}
                                helperText={formik.touched.state && formik.errors.state}
                            />
                        )}
                    />

                </div>
            </div>
            <div className="user-name-billing-selection-container">
                <div className="user-name-billing-selection-label">
                    <H6>Select billing name</H6>
                </div>
                <div className="user-name-billing-selection-input">
                    <FormControl component="fieldset">
                        <RadioGroup
                            name="billing"
                            value={formik.values.billing || null}
                            onChange={(event) => formik.setFieldValue("billing", event.target.value)}
                        >
                            {uniqueAttendees.map((user, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={user}
                                    control={<Radio />}
                                    label={
                                        <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
                                            <Body2 style={{ minWidth: "150px" }}>{user.name}</Body2>
                                            <Body2 style={{ minWidth: "120px" }}>{user.phone}</Body2>
                                            <Body2>{user.email}</Body2>
                                        </div>
                                    }
                                    checked={formik.values.billing?.ticket_id === user.ticket_id} // compare by unique id
                                    onClick={() => formik.setFieldValue("billing", user)}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>

                </div>
            </div>
        </div>
    )
}

export default BillingDetails